import { DxFormGroup } from './form-group';
import { NGXLogger } from 'ngx-logger';
import { Type } from '@angular/core';
import {
  ASYNC_VALIDATOR_KEY,
  CONTROL_METADATA_KEY,
  FORM_ARRAY_METADATA_KEY,
  FORM_GROUP_METADATA_KEY,
  ON_SET_VALUE_KEY,
  VALIDATOR_KEY
} from './decorators/metadata-keys';
import {
  DxFormAsyncValidatorDefinition,
  DxFormControlDefinition,
  DxFormArrayDefinition,
  DxFormGroupDefinition,
  DxFormOnSetValueDefinition,
  DxFormValidatorDefinition
} from './decorators/interfaces';
import {
  getMetadataKeys,
  getMetadata
} from '@digitaix/helpers';

export class FormRegisterBuilder {
  public readonly formSourcePrototype: any;
  public controls: DxFormControlDefinition<any>[] = [];
  public groups: DxFormGroupDefinition<any>[] = [];
  public arrays: DxFormArrayDefinition<any>[] = [];
  public asyncValidators: DxFormAsyncValidatorDefinition<any, any>[] = [];
  public onSetValues: DxFormOnSetValueDefinition[] = [];
  public validators: DxFormValidatorDefinition<any, any>[] = [];

  constructor(
    public readonly formGroupConstructor: Type<DxFormGroup<any, any, any>>,
    public readonly logger: NGXLogger
  ) {
    this.formSourcePrototype = formGroupConstructor.prototype;
    this.extractMetadata();
  }

  public extractMetadata(): void {
    this.logger.debug(
      `[FormRegisterBuilder::extractMetadata::${
        this.formGroupConstructor.name
      }] extract metadata from`,
      this.formSourcePrototype
    );

    const metadataKeys = getMetadataKeys(this.formSourcePrototype);

    for (const metadataKey of metadataKeys) {
      const metadata = getMetadata<any[]>(
        metadataKey,
        this.formSourcePrototype
      );

      this.logger.debug(
        `[FormRegisterBuilder::extractMetadata::${
          this.formGroupConstructor.name
        }] metadata`,
        metadata
      );

      switch (metadataKey) {
        case FORM_GROUP_METADATA_KEY:
          this.groups = metadata;
          break;

        case ON_SET_VALUE_KEY:
          this.onSetValues = metadata;
          break;

        case CONTROL_METADATA_KEY:
          this.controls = metadata;
          break;

        case ASYNC_VALIDATOR_KEY:
          this.asyncValidators = metadata;
          break;

        case VALIDATOR_KEY:
          this.validators = metadata;
          break;

        case FORM_ARRAY_METADATA_KEY:
          this.arrays = metadata;
          break;
      }
    }
  }
}
